import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({
  title,
  description,
  image,
  url,
  type = 'website',
  structuredData,
  noindex = false,
  nofollow = false,
}) => {
  const location = useLocation();
  const siteUrl = 'https://flowto-ai.com';
  const siteName = 'Flowto.AI';
  const defaultImage = '/images/og-default.png';
  const defaultDescription =
    'Flowto.AI는 AI 프로덕트 스튜디오입니다. 여행, 건강·습관, 비즈니스 검증, 생활 도구 — 일상에서 쓰는 서비스를 만듭니다.';

  // URL 생성
  const fullUrl = url ? `${siteUrl}${url}` : `${siteUrl}${location.pathname}`;
  const fullImage = image ? (image.startsWith('http') ? image : `${siteUrl}${image}`) : `${siteUrl}${defaultImage}`;
  
  // Title 생성
  const fullTitle = title ? `${title} - ${siteName}` : siteName;
  
  // Description 생성
  const metaDescription = description || defaultDescription;

  // Robots 메타 태그
  const robotsContent = [];
  if (noindex) robotsContent.push('noindex');
  if (nofollow) robotsContent.push('nofollow');
  if (robotsContent.length === 0) robotsContent.push('index', 'follow');

  return (
    <Helmet>
      {/* 기본 메타 태그 */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="robots" content={robotsContent.join(', ')} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph 태그 */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="ko_KR" />

      {/* Twitter Card 태그 */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* 구조화된 데이터 (JSON-LD) */}
      {structuredData && (
        Array.isArray(structuredData) ? (
          structuredData.map((data, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(data)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        )
      )}
    </Helmet>
  );
};

export default SEO;
